export default __webpack_public_path__ + "static/media/2439.a33a7fde.png";